import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import { VueMaskDirective } from 'v-mask'
import App from './App'
import router from './router'

// Translations
import GetTextPlugin from 'vue-gettext'
import translations from './locale/translations.json'

function getBrowserLocale() {
  var lang
  if (navigator.languages && navigator.languages.length) {
    lang = navigator.languages[0]
  } else if (navigator.userLanguage) {
    lang = navigator.userLanguage
  } else {
    lang = navigator.language
  }
  lang = lang.split('-')[0]
  return lang
}

Vue.use(GetTextPlugin, {
  translations: translations,
  silent: true,
  availableLanguages: {
    de: 'Deutsch'
  },
  defaultLanguage: getBrowserLocale()
})

Vue.use(VueAnalytics, {
  id: 'UA-87758735-2',
  router
})

// Vendors
//// Bootstrap
import '../node_modules/bootstrap-material-design/dist/css/bootstrap-material-design.css'
import '../node_modules/bootstrap-material-design/dist/js/bootstrap-material-design'
//// Material design icons
import '../node_modules/material-design-icons-iconfont/dist/material-design-icons.css'
//// Leaflet
import '../node_modules/leaflet/dist/leaflet.css'
// Main custom styles
import './styles/main.scss'

Vue.directive('mask', VueMaskDirective)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
